import { render, staticRenderFns } from "./ConfirmationDialog.vue?vue&type=template&id=8bcc368c&scoped=true&"
import script from "./ConfirmationDialog.vue?vue&type=script&lang=ts&"
export * from "./ConfirmationDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmationDialog.vue?vue&type=style&index=0&id=8bcc368c&scoped=true&lang=css&"
import style1 from "./ConfirmationDialog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bcc368c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle,VCol,VDialog,VDivider,VRow})
